class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();
    

    
    $.getJSON('/cart.js', function(cart){
//       console.log(cart);
      if(cart.total_price > 50000){
        $("#cart-notification-form button").removeAttr("disabled");
        $('#cart-disabled-error').html('');
      }
      else if(cart.total_price < 50000){
        $('#cart-notification-form button').prop('disabled', true);
        $('#cart-disabled-error').html('Minimum Order Value ₹500');
      }
      else {
      }
    });
    
    
    $.getJSON('/cart.js', function(cart){
      if(cart.total_price < 99900){
        $("[cart-offer-1]").css({
          'display' : 'block',
        });
        $('[cart-offer-2]').css({
          'display' : 'none',
        });
      }
      else if(cart.total_price >= 99900){
        $('[cart-offer-1]').css({
          'display' : 'none',
        });
        $('[cart-offer-2]').css({
          'display' : 'block',
        });
      }
      else {
      }
    });


      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
